
import {defineComponent} from 'vue'
import BaseTitle from '@/components/UI/BaseTitle.vue'
import {FormMixin} from '@/components/base/FormMixin'
import BaseOffcanvas from '@/components/UI/Bootstrap/Offcanvas/BaseOffcanvas.vue'
import InputSelect from '@/components/UI/InputSelect.vue'
import MailingMailTemplateDetail from './MailingMailTemplateDetail.vue'
import {Storage} from '@/models/facade/Storage'
import {SessionStorageKeyEnum} from '@/models/enum/SessionStorageKeyEnum'
import {DpModuleEnum} from '@/api/enums/dp-module-enum'
import {PageDetailModeEnum} from '@/models/enum/PageDetailModeEnum'
import {MailingMailTemplateRestService} from '@/services/rest/master/MailingMailTemplateRestService'
import {MailingMailTemplateOverviewResultsRestDto} from '@/api/pharma-master-mailing-template-library/models'
import GenericFormWrapper from '@/components/base/GenericFormWrapper.vue'
import MailingMailTemplateOverviewItem from '@/components/layouts/mailing-template/MailingMailTemplateOverviewItem.vue'

export default defineComponent({
  name: 'MailingMailTemplateOverview',
  mixins: [FormMixin],
  components: { GenericFormWrapper, InputSelect, BaseOffcanvas, BaseTitle, MailingMailTemplateDetail, MailingMailTemplateOverviewItem },
  data: () => ({
    module: DpModuleEnum.ORDER,
    allModules: [
      {code: DpModuleEnum.ORDER, description: DpModuleEnum.ORDER},
      {code: DpModuleEnum.CPC, description: DpModuleEnum.CPC},
      {code: DpModuleEnum.AUTH, description: DpModuleEnum.AUTH}
    ],
    templates: null as MailingMailTemplateOverviewResultsRestDto | null,
    detailMode: PageDetailModeEnum.NEW,
    selectedTemplateId: undefined as string | undefined,
    templateSequence: 0 as number,
  }),
  mounted() {
    this.initialize();
  },
  computed: {
    PageDetailModeEnum() { return PageDetailModeEnum }
  },
  methods: {
    async doInitialize(): Promise<void> {
      this.module = Storage.session.get(SessionStorageKeyEnum.NOTIFICATION_TEMPLATE_MODULE) ?? DpModuleEnum.ORDER;
    },
    async doReload(): Promise<void> {
      this.templates = await MailingMailTemplateRestService.getInstance().findMailingMailTemplates(this.module);
      Storage.session.set(SessionStorageKeyEnum.NOTIFICATION_TEMPLATE_MODULE, this.module);
    },
    async deleteTemplate(item: any): Promise<void> {
      await this.deleteItemWithKey(item.id);
    },
    openDetail(item: any): void {
      this.selectedTemplateId = item.id;
      this.detailMode = PageDetailModeEnum.EDIT;
      this.templateSequence++;
      this.openOffCanvas('mailingMailTemplateOffCanvas');
    },
    openNew(): void {
      this.selectedTemplateId = undefined;
      this.detailMode = PageDetailModeEnum.NEW;
      this.templateSequence++;
      this.openOffCanvas('mailingMailTemplateOffCanvas');
    },
    async doDeleteItemWithKey(_id: string): Promise<void> {
      alert('Not yet implemented');
    },
  }
})
